export var routes = [
    { route: '', redirect: 'landing' },
    { name: 'landing', title: 'Home', route: 'landing', nav: true, moduleId: 'public/landing' },
    { name: 'register_legacy', route: 'register', redirect: 'landing' },

    { name: 'registration', route: 'registration', moduleId: 'public/register/index' },
    { name: 'login', route: 'login', moduleId: 'public/login/index' },
    { name: 'password-changed', route: 'password-changed', moduleId: 'public/login/password-changed' },
    { name: 'signup', route: 'signup', moduleId: 'public/login/no-user-account' },
    { name: 'no-access', route: 'no-access', moduleId: 'public/login/no-user-account' },
    { name: 'not-found', route: 'not-found', moduleId: 'public/system/not-found/index' },
];